import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { TNavigationStack, TNavigationStackWithParams } from 'app/types';
import { usePost } from 'app/queryProvider';
import { useAuth } from 'app/auth/hooks/useAuth';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { ToastNotifications } from 'app/services/inAppToastNotifications';
import { DrugIntakeWindowSelectForm } from '../components/forms';
import { Loading } from '@shared/components/loading';
import { IDrugIntakeRequest, TDrugSlot } from '../types';
import { TActivityBucket } from '../utils/activityCard';

const DrugIntakeWindowSelectScreen = () => {
  const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityId: string, prescribedWindow: TActivityBucket }>, 'DrugIntakeWindowSelect'>>();
  const { activityId, prescribedWindow } = route.params;
  const { meData } = useAuth();
  const { t } = dynamicTranslations();

  const navigation = useNavigation<NativeStackNavigationProp<TNavigationStack>>();

  const { mutate: createDrugIntake, isPending: isCreatingDrugIntake } = usePost<IDrugIntakeRequest, undefined>({
    options: {
      onSuccess: (_data, variables) => {
        navigation.navigate("ActivitySuccess", {
          administered: true,
          activityType: 'drug',
          actualWindow: variables.data.actual_window,
          prescribedWindow,
        });
      },
      onError: () => {
        ToastNotifications.displayErrorNotification(t('drugs.windowSelect.submitError'));
      },
    },
  });

  const handleGoToHome = () => {
    navigation.navigate("Homepage");
  };

  const handleSubmit = (slot: TDrugSlot) => {
    createDrugIntake({
      resource: { name: "pathways", id: meData?.current_pathway.id },
      url: `/activities/${activityId}/drug-intake`,
      data: {
        administered: true,
        actual_window: slot,
      },
    });
  };

  if (isCreatingDrugIntake) {
    return <Loading />
  }

  return (
    <MainLayout navigation={handleGoToHome} scrollable={true}>
      <DrugIntakeWindowSelectForm handleSubmit={handleSubmit} />
    </MainLayout>
  );
};

export default DrugIntakeWindowSelectScreen;
